import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { without, update, findIndex } from 'ramda';
let TeamsStore = class TeamsStore extends VuexModule {
    teams = [];
    currentTeam = null;
    setTeam(team) {
        if (this.currentTeam) {
            this.teams = update(findIndex((a) => team === a, this.teams), team, this.teams);
        }
        else {
            this.teams.push(team);
        }
    }
    setCurrentTeam(team) {
        this.currentTeam = team;
    }
    removeTeam(team) {
        this.teams = without([team], this.teams);
    }
};
__decorate([
    Mutation
], TeamsStore.prototype, "setTeam", null);
__decorate([
    Mutation
], TeamsStore.prototype, "setCurrentTeam", null);
__decorate([
    Mutation
], TeamsStore.prototype, "removeTeam", null);
TeamsStore = __decorate([
    Module({
        namespaced: true,
    })
], TeamsStore);
export default TeamsStore;
